import React from "react";
const SectionGuard = ({ children=null, canAccess, ...props }) => {
  if (canAccess) {
    return children;
  }
  return false;
};
export default SectionGuard;
